export default (data: any) => {
  return data;
};
